import * as React from "react"
export const Row = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`flex flex-row ${className}`}
    {...props} />
))
